<ui-title [title]="'User & Role Blacklist'">

	<ui-loading class="col-lg-6 float-right" [loadingText]="'loading blacklist'" [loading]="blacklist.loading">
	</ui-loading>
</ui-title>

<div class="page-blacklist">
	<div class="col-lg-12">
		<ui-table [chunker]="blacklist.chunker" (chunked)="blacklist.chunkedData = $event" [filters]="true" [headers]="[
			{label: 'System Name',filterable:true,idFunction: blacklist_idSystemName},
			{label: 'System loader Name',filterable:true,idFunction: blacklist_idSystemLoaderName},
			{id: 'UserName',label: 'User Local Alias',filterable:true},
			{id: 'RoleName',label: 'Role Name',filterable:true},
			{id: 'CreatedDate',label: 'Created',filterable:false},
			{id: 'Reason',label: 'Reason',filterable:true},
			{id: '',label: '',filterable:false},
	]">
			<tr *ngFor="let blr of blacklist.chunkedData" [class]="'helper-clickable'">
				<td>{{blr.SystemLoader.System.Name}}</td>
				<td>{{blr.SystemLoader.Name}}</td>
				<td>{{blr.UserName}}</td>
				<td>
					<i class="badge alert-warning" *ngIf="blr.RoleName==null" matTooltip="this role has been registered as the null value in the database, it is not an empty string">null</i>
					<span *ngIf="blr.RoleName!=null">{{blr.RoleName}}</span>
				</td>
				<td>{{blr.CreatedDate|date}}</td>
				<td>{{blr.Reason}}</td>
				<td><button class="btn btn-danger" type="button" (click)="blacklist_delete(blr)">Delete</button></td>
			</tr>
		</ui-table>
	</div>


	<div class="card-body ">
		<div class="card">
			<div class="card-header">New User & Role Blacklisted entry</div>
			<div class="card-body" [hidden]="!newBlacklist.saving">
				<ui-loading [loading]="true"></ui-loading>
			</div>
			<div class="card-body" [hidden]="newBlacklist.saving" style="margin-bottom: 20px;">
				<div class="form-group row mt-3">
					<label class="col-lg-2">
						System Loader
					</label>
					<div class="col-lg-4">
						<select [(ngModel)]="newBlacklist.data.SystemLoaderId" class="form-control">
							<ng-container *ngFor="let s of blacklist.systems">
								<option *ngFor="let l of s.Loaders" [value]="l.Id">{{s.Name}} - {{l.Name}}</option>
							</ng-container>
						</select>
					</div>
				</div>
				<div class="form-group row mt-3">
					<label class="col-lg-2">
						Local User Alias
					</label>
					<div class="col-lg-4">
						<input type="text" [(ngModel)]="newBlacklist.data.UserName" class="form-control" />
					</div>
				</div>
				<div class="form-group row mt-3">
					<label class="col-lg-2">
						Role is Null ?
					</label>
					<div class="col-lg-4">
						<mat-checkbox [matTooltip]="'Click if the role is empty'" color="primary"
							[(ngModel)]="newBlacklist.nullRole" [checked]="newBlacklist.nullRole"
							name="newBlacklist.hasRole"></mat-checkbox>
					</div>
				</div>
				<div class="form-group row mt-3">
					<label class="col-lg-2">
						Role Name
					</label>
					<div class="col-lg-4">
						<input type="text" [(ngModel)]="newBlacklist.data.RoleName" [readonly]="newBlacklist.nullRole" class="form-control" />
					</div>
				</div>
				
				<div class="form-group row mt-3">
					<label class="col-lg-2">
						Reason
					</label>
					<div class="col-lg-4">
						<input type="text" [(ngModel)]="newBlacklist.data.Reason" class="form-control" />
					</div>
				</div>
				<div class="form-group row">
					<div class="col-lg-2">

						<button mat-button class="button btn-primary" (click)="newBlacklist_save()">
							Add
						</button>
					</div>
				</div>
			</div>
		</div>

	</div>